import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, Tab, Tabs, Nav, Accordion } from 'react-bootstrap';
import { BrowserRouter, Route, Switch, Router, NavLink, useParams } from 'react-router-dom';
import LoanRibbenBox from './LoanRibbenBox'
import DocumentGallery from './DocumentGallery';
import { GET_CUSTOMER_DETAILS, GET_OPSEE_DOCUMENT_LIST, GET_OPSEE_FORM_FIELDS } from "../../../../services/inventory-funding/opsee.gql";
import { useApolloClient } from "@apollo/client";
import { executeGraphQLQuery } from "../../../../services/inventory-funding/executeGraphQLQuery";
import { toast } from "react-toastify";
import crypto from "../../../../config/crypto";
import Loader from "../../elements/Loader";
import SurveyPDF from "../SurveyPDF";

const FCILeadDetails = (props) => {
  const client = useApolloClient();
  const {customer_id} = useParams();
  const [loading, setLoading] = useState({});
  const [documentList, setDocumentList] = useState([]);
  const [formFields, setFormFields] = useState({});
  const [customerDetails, setCustomerDetails] = useState({});
  const [activeTab, setActiveTab] = useState();
  const [activeSurveyIndex, setActiveSurveyIndex] = useState(0);
  const initialDataRef = useRef(null);
  const isFetchedRef = useRef(false);

  useEffect(()=> {
    if (isFetchedRef.current) return;
    isFetchedRef.current = true;

    getCustomerDetails(+crypto.decode(customer_id));
  },[])

  const getDocumentList = async (survey_type_id) => {
    setLoading(true);
    executeGraphQLQuery(GET_OPSEE_DOCUMENT_LIST(),{survey_type_id}, client)
    .then((res) => {
    if(res?.data){
      setDocumentList(res?.data?.masterdata?.document_list_opsee);
      setLoading(false);
    }else{
      toast.error("Something went wrong")
      setLoading(false);
    }
    })
    .catch((error) => {
      setLoading(false);
        toast.error(error.toString().replace('ApolloError:',''));
    });  
  }

  const getFormFields = async (survey_type_id) => {
    setLoading(true);
    executeGraphQLQuery(GET_OPSEE_FORM_FIELDS(),{survey_type_id}, client)
    .then((res) => {
    if(res?.data){
      setFormFields(res?.data?.get_opsee_form_fields);
      setActiveTab(res?.data?.get_opsee_form_fields?.sections?.[0]?.title)
      setLoading(false);
    }else{
      setLoading(false);
      toast.error("Something went wrong")
    }
    })
    .catch((error) => {
      setLoading(false);
        toast.error(error.toString().replace('ApolloError:',''));
    });  
  }

  const getCustomerDetails = async (customer_id,task_id=0,initialLoadFlag=true) => {
    setLoading(true);
    let variables = {
      customerDetailsInput: {
        source: 'opsee',
        customer_id: customer_id
      }
    };
    if(task_id > 0) variables['customerDetailsInput']['task_id'] = task_id;
    executeGraphQLQuery(GET_CUSTOMER_DETAILS(),variables, client)
    .then((res) => {
    if(res?.data){
      if(initialLoadFlag) initialDataRef.current = res?.data?.customer_details;
      setCustomerDetails(res?.data?.customer_details);
      let surveyTypeId = res?.data?.customer_details?.surveys?.[0]?.survey_type_id;
      getFormFields(surveyTypeId);
      getDocumentList(surveyTypeId);
    }else{
      setLoading(false);
      toast.error("Something went wrong")
    }
    })
    .catch((error) => {
      setLoading(false);
        toast.error(error.toString().replace('ApolloError:',''));
    });  
  }

  const handleDownload = () => {
    setLoading(true);
    if(Object.keys(customerDetails).length) {
      const element = document.getElementById("survey-pdf");
      const opt = {
        margin: 10,
        filename: `Survey Report - ${customerDetails?.pb_full_name}_${customerDetails?.id}`,
        html2canvas: { scale: 2 ,useCORS: true, allowTaint: true },
        jsPDF: { unit: "mm", format: "a4" },
      };

      window.html2pdf().set(opt).from(element).save();
      setLoading(false);
    }
  }

  let originalData = initialDataRef.current || {};
  console.log("**********",customerDetails)

  return (
    <React.Fragment>
      {loading ? <Loader /> : <></>}
      <div className="container-fluid">
        <div className="loan-bx-ribben fci-flow-top-ribben">
          <div className="top-heading">
            <h1>FCI Survey Panel</h1>
          </div>
          <LoanRibbenBox customerDetails={customerDetails}/>
        </div>
        <div className="lead-detail-tabs m-md-t">
          <Tab.Container id="left-tabs-example" activeKey={activeSurveyIndex} onSelect={(k) => setActiveSurveyIndex(+k)}>

          <Nav variant="pills" className="flex-column">
            <div className="tab-list">
              {originalData?.surveys?.map((item, index) => (
                <Nav.Item key={item.id}>
                  <Nav.Link eventKey={index} onClick={()=> getCustomerDetails(item.customer_id,item.id,false)} style={{fontSize:"10px"}}>
                    {item.surveyType.name}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </div>
          </Nav>


            <Tab.Content>
            {originalData?.surveys?.map((item, index) => (
              <Tab.Pane eventKey={index} key={item.id}>


                <div className="detail-form-sec">

                  <div className="menu-tab-left-panel">
                    <div className="dealer-tab-left-panel nav">
                    <ul>
                      {formFields?.sections?.map((item) => (
                        <li key={item.id}>
                          <NavLink
                            to=""
                            className={`active ${Object.values(customerDetails?.survey_details[item.key] || {})?.filter(val => !["",null].includes(val))?.length === item?.fields?.length ? "completed" : ""}`}
                            aria-current="page"
                            exact
                            onClick={()=> setActiveTab(item.title)}
                          >
                            <span className="img-type"></span>
                            {item.title}
                          </NavLink>
                        </li>
                      ))}
                    </ul>


                    </div>
                  </div>

                  <div className="route-files">
                    <div className="image-form-outer">
                      <div className="image-tab-panel">
                        <DocumentGallery customerDetails={customerDetails} documentList={documentList}/>
                      </div>
                      <div style={{ display: 'none' }}>
                          {customerDetails && <SurveyPDF data={customerDetails} />}
                      </div>
                      <div className="form-tab-right-panel">

                        <div className="lead-detail-from-outer">
                          <span style={{"display":"flex","justifyContent":"end"}}>Task status:&nbsp;<span style={{"color": `${customerDetails?.surveys?.[0]?.task_status === '3' ? '#30b38a' : customerDetails?.surveys?.[0]?.task_status === '5' ? '#FFA340' : 'red'}`}}>{customerDetails?.surveys?.[0]?.task_status === '3' ? 'Completed' : customerDetails?.surveys?.[0]?.task_status === '5' ? 'Cancelled' : 'Pending'}</span></span>
                          {formFields?.sections?.filter(v=> v.title === activeTab)?.map(item=> (<>
                          <div className="lead-form-heading">
                            <h2>{item.title}</h2>
                          </div>
                          
                          <div className="lead-form-filed radio-btn">
                            <div className="row">
                            {item?.fields?.map(field => (
                              <fieldset key={field.id} className="form-filed col-md-6">
                                <div className="material">
                                  <input
                                    title={customerDetails?.survey_details?.[item.key]?.[field.name] || ""}
                                    type={"text"}
                                    placeholder=" "
                                    name={field.name}
                                    className="form-input"
                                    value={customerDetails?.survey_details?.[item.key]?.[field.name] || ""}
                                    disabled={true}
                                  />
                                  <label
                                    data-label={field.label?.substring(0,20)}
                                    className="form-label"
                                  />
                                </div>
                              </fieldset>
                            ))}

                            </div>
                          </div>
                           {customerDetails?.surveys?.[0]?.task_status === '3' && <button className="btn-primary" onClick={handleDownload}>Download Survey</button>}
                          </>
                          ))}
                        </div>
                      </div>

                    </div>
                  </div>

                </div>


              </Tab.Pane>
            ))}
            </Tab.Content>

          </Tab.Container>



        </div>

      </div>
    </React.Fragment>
  )
}

export default FCILeadDetails;